module.exports = __webpack_public_path__ + "img/tache.9284bd12.png";